import Swal from 'sweetalert2'
import i18n from '../i18n'
class ServerApiError {
    constructor(error){
        this.error = error;
    }
    alert(){
        Swal.fire({
            icon: 'error',
            confirmButtonText: i18n.global.t("go to finish page"),
            title:i18n.global.t(this.error)
        })
    }
}
export default ServerApiError;